import {
  Button,
  RadioGroup
} from '../../../form_components';
import { downloadDuplicateIdCsv } from './download-duplicate-id-csv';
import { fixOrNotOptions } from './fix-or-not-options';

/** Used to validate that there are not duplicate IDs on the design. */
export const CheckDuplicateIds = ({
  duplicateIdItems,
  onShouldFixChange,
  serialized,
  shouldFix
}) => {
  if (!duplicateIdItems?.length) {
    return (
      <div>
        No duplicate IDs to display.
      </div>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <RadioGroup
            label={`Should Fix Duplicates (${duplicateIdItems.length})`}
            name="duplicate-id-fix"
            onChange={() => {
              onShouldFixChange(!shouldFix);
            }}
            options={fixOrNotOptions}
            value={shouldFix}
          />
        </div>
        <div className="col-md-6 flex-end">
          <Button
            label="Download CSV"
            callback={() => {
              downloadDuplicateIdCsv({
                duplicateIdItems,
                serialized
              });
            }}
          />
        </div>
      </div>
    </>
  );
};
